import { ReactElement, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useGetUserinfo } from '../../hooks/queries/useGetUserinfo';
import { Routes } from '../../enums/Routes';
import { TeamLeaderRolesUtils } from '../../utils/RolesUtils/TeamLeaderRoles.utils';
import { PageProblem } from './PageProblem';
import { startPageFor } from './startPage';

/**
 * The team leader's part of the app: the team dashboards, the surveys and the teams. Only for those who lead a team,
 * and the administrator who sets them up. Others are told they have no access, instead of a dashboard half filled
 * for a team they do not lead. The overview the login opens takes them to their own start page instead. The API
 * decides what they may see; this only spares them a page that cannot work.
 */
export const RequireTeamLeader = ({ children }: { children: ReactNode }): ReactElement | null => {
  const { data, isLoading } = useGetUserinfo();
  const { pathname } = useLocation();
  // Nothing is shown until the roles are known, so the page does not flash
  if (isLoading) return null;
  const roles = data?.userRoles ?? [];
  const leadsTeam = data?.leadsTeam ?? false;
  if (TeamLeaderRolesUtils.hasTeamLeaderPart(roles, leadsTeam)) return <>{children}</>;
  if (pathname === Routes.Dashboard) return <Navigate to={startPageFor(roles, leadsTeam)} replace />;
  return <PageProblem kind="noAccess" />;
};
